
<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1 class="titleColor text-2xl font-bold" i18n="@@instapayAccount">InstaPay Account</h1>

    <a
      routerLink="/"
      class="add-button flex items-center justify-center gap-2">
      <app-add-icon/>
      <span i18n="@@instapayAddAccount">Add InstaPay Account</span>
    </a>
  </div>
</div>


<div class="mt-3 rounded-2xl bg-white p-4 shadow-md">
<app-instapay-list-component/>
</div>


